module.exports = __webpack_public_path__ + "img/green-monitor.057b7de2.png";